<div id="forms" class="page-layout simple fullwidth" fxLayout="column">

    <!-- HEADER -->
    <div class="header accent p-24 h-160" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="column" fxLayoutAlign="center start">
            <h1 class="pt-32"></h1>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="h1 pt-32" style="padding-left: 2%;">
        Videos para el administrador
    </div><br>
    <div fxLayout="row" fxLayoutAlign="space-around center">
    </div>
    <!--*ngIf="password" -->
    <ng-container>
        <div class="content p-24" class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
            <table class="blueTable">
                <thead>
                    <tr>
                        <th *ngFor="let producto of videos1">
                            {{producto.titulo}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td *ngFor="let producto of videos1">
                            <video id="videoLanding" style="width: 90%; " src="{{producto.liga}}" controlslist="nodownload" controls fxLayoutAlign="start start"></video>
                        </td>
                    </tr>
                    <tr>
                </tbody>
            </table>
        </div>
        <div class="content p-24">
            <table class="blueTable">
                <thead>
                    <tr>
                        <th *ngFor="let producto of videos2">
                            {{producto.titulo}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td *ngFor="let producto of videos2">
                            <video id="videoLanding" style="width: 90%; height: 280px!important;" src="{{producto.liga}}" controlslist="nodownload" controls fxLayoutAlign="start start"></video>
                        </td>
                    </tr>
                    <tr>
                </tbody>
            </table>

        </div>
        <div class="content p-24">
            <table class="blueTable">
                <thead>
                    <tr>
                        <th *ngFor="let producto of videos3">
                            {{producto.titulo}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td *ngFor="let producto of videos3">
                            <video id="videoLanding" style="width: 90%; height: 280px!important;" src="{{producto.liga}}" controlslist="nodownload" controls fxLayoutAlign="start start"></video>
                        </td>
                    </tr>
                    <tr>
                </tbody>
            </table>
        </div>
        <div class="content p-24">
            <table class="blueTable">
                <thead>
                    <tr>
                        <th *ngFor="let producto of videos4">
                            {{producto.titulo}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td *ngFor="let producto of videos4">
                            <video id="videoLanding" style="width: 90%; height: 280px!important;" src="{{producto.liga}}" controlslist="nodownload" controls fxLayoutAlign="start start"></video>
                        </td>
                    </tr>
                    <tr>
                </tbody>
            </table>

        </div>
        <div class="content p-24">
            <table class="blueTable">
                <thead>
                    <tr>
                        <th *ngFor="let producto of videos5">
                            {{producto.titulo}}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td *ngFor="let producto of videos5">
                            <video id="videoLanding" style="width: 90%; height: 280px!important;" src="{{producto.liga}}" controlslist="nodownload" controls fxLayoutAlign="start start"></video>
                        </td>
                    </tr>
                    <tr>
                </tbody>
            </table>

        </div>

    </ng-container>


    <!-- / CONTENT -->

</div>